import { RemoteConfiguration, RemotesConfiguration } from '@inform-appshell/fusion-kit-contracts';
import { ConfigurationManager } from '@inform-appshell/fusion-kit-core';

export const getAllBootstrapableModules = (
  remotesConfiguration: RemotesConfiguration
): { remote: string; module: string }[] => {
  const bootstrapableModules: { remote: string; module: string }[] = [];

  remotesConfiguration.remotes.forEach((remote) => {
    if (remote.exposedModules) {
      // Find all bootstrap modules in this remote
      const bootstrapModules = Object.entries(remote.exposedModules)
        .filter(([value]) => value === 'bootstrap')
        .map(([key]) => key);

      // Log or process bootstrap modules
      if (bootstrapModules.length > 0) {
        bootstrapModules.forEach((moduleName) => {
          bootstrapableModules.push({
            remote: remote.name,
            module: moduleName,
          });
        });
      }
    }
  });

  return bootstrapableModules;
};

export const getRemotesConfigFromConfigManager = (configManager: ConfigurationManager): RemotesConfiguration => {
  const modules: RemoteConfiguration[] = configManager.getContent<RemoteConfiguration[]>('modules') ?? [];
  const resolvedModules = modules.map((remote) => ({
    ...remote,
    url: remote.url.startsWith('http') ? remote.url : window.location.origin + remote.url,
  }));
  // No `shared` block: FederationModuleManager never reads `config.shared`, and
  // fusion-kit's vite loader calls `remoteModule.init()` with no arguments, so the
  // remote's share scope is always empty. The entries that used to sit here looked
  // like a working singleton channel but were dead code — see ADR-0023.
  return {
    appName: 'cuam',
    remotes: resolvedModules,
  };
};
